import React from 'react';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { AiOutlineMenu } from "react-icons/ai"


import getScript from "../language";
import "../css/layout/Header.css";


const Header = (props) => {
    const script = getScript("header")
    const language =
        useSelector(state => state.user.language) ||
        localStorage.getItem("language") ||
        "en"


    function showMenu() {
        let mobileMenu = document.getElementById('mobileMenuContainer');
        mobileMenu.style.marginLeft = "0%";
        setTimeout(() => {
            mobileMenu.style.backgroundColor = "rgb(158 158 156 / 60%)";
        }, 300)
    }
    return (
        <div>
            <div id='headerContainer'>
                <div id="headerLogo">
                    <Link to="/">{script.name}</Link>
                </div>
                <div id="headerNav">
                    <Link to="/">{script.home}</Link>
                    <Link to="/about">{script.about}</Link>
                    <a href="https://ecommerce.unitechparts.com">{script.product}</a>
                    <Link to="/contact">{script.contact}</Link>
                </div>
                <div id="headerLang">
                    <span
                        className={
                            language === "ko"
                                ? "headerLang_option headerLang_active"
                                : "headerLang_option"
                        }
                        onClick={() => props.changeLanguage("ko")}
                    >
                        KO
                    </span>
                    <span className="headerLang_divider">/</span>
                    <span
                        className={
                            language === "en"
                                ? "headerLang_option headerLang_active"
                                : "headerLang_option"
                        }
                        onClick={() => props.changeLanguage("en")}
                    >
                        EN
                    </span>
                </div>
                <div id="headerMobileIcon">
                    <AiOutlineMenu
                        className="header_mobileMenu"
                        size={30}
                        color={"black"}
                        onMouseEnter={() => {
                            //changeColorIn(4)
                        }}
                        onMouseLeave={() => {
                            //changeColorOut(4)
                        }}
                        onClick={showMenu}
                    />
                </div>
            </div>
            <div id="headerBottomLine"></div>
        </div>
    )
}

export default Header;
